export const HOME_MV_SETTINGS = {
  embla: {
    loop: true,
    align: "start" as const,
    duration: 40,
  },
  autoplay: {
    delayMs: 4000,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
    playOnInit: true,
  },
  animation: {
    // Image
    backgroundFadeStartSec: 0,
    backgroundFadeDurationSec: 2.0,
    backgroundFadeEase: "power1.out",
    // Main Title
    titleFadeStartSec: 0.7,
    titleFadeDurationSec: 1.5,
    titleFadeEase: "power2.out",
    titleCharFadeDurationSec: 2.8,
    titleCharStaggerSec: 0.07,
    // Copy
    copyFadeStartSec: 1.8,
    copyFadeDurationSec: 1.2,
    copyFadeEase: "none",
    // Header
    headerFadeStartSec: 1.8,
    headerFadeDurationSec: 1.2,
    headerFadeEase: "power2.out",
    // Slide Scale
    slideScaleStart: 1.1,
    slideScaleEnd: 1,
    slideScaleDurationSec: 3.5,
    slideScaleEase: "power3.out",
    previousSlideExitScaleDurationSec: 0.4,
  },
};
